import { jsxs, jsx } from "react/jsx-runtime";
const IconPropertyHouseSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.335 4.176a.72.72 0 0 1 .72.72v17.002a.72.72 0 0 1-1.44 0V4.896a.72.72 0 0 1 .72-.72Zm17.003 0a.72.72 0 0 1 .72.72v7.847a.72.72 0 0 1-1.44 0V4.896a.72.72 0 0 1 .72-.72Zm0 13.734a.72.72 0 0 1 .72.718v3.27a.72.72 0 1 1-1.44 0v-3.27a.72.72 0 0 1 .72-.719Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.338 17.844a1.831 1.831 0 1 0 0-3.662 1.831 1.831 0 0 0 0 3.662Zm0 1.438a3.27 3.27 0 1 0 0-6.539 3.27 3.27 0 0 0 0 6.54ZM11.228.135c.386-.18.831-.18 1.217 0l9.505 4.436a.72.72 0 0 1-.608 1.303L11.837 1.44 2.33 5.874a.72.72 0 0 1-.608-1.303L11.228.135ZM0 22.225a.72.72 0 0 1 .72-.72h22.56a.72.72 0 0 1 0 1.44H.72a.72.72 0 0 1-.72-.72ZM10.954 9.571v1.766h1.765V9.571h-1.765Zm-.425-1.079a.654.654 0 0 0-.654.654v2.616c0 .361.292.654.654.654h2.615a.654.654 0 0 0 .654-.654V9.146a.654.654 0 0 0-.654-.654H10.53Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.954 16.765v4.381h1.765v-4.381h-1.765Zm-.425-1.08a.654.654 0 0 0-.654.655v5.885h3.923V16.34a.654.654 0 0 0-.654-.654H10.53Z"
        }
      )
    ]
  }
);
export {
  IconPropertyHouseSvg
};
